<template>
  <div>
    <v-card :elevation="0">
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="12" md="12" class="d-flex justify-start">
            <div :style="icon_style" class="d-flex justify-center py-1 px-2">
              <v-icon :color="icon_color">{{icon}}</v-icon>
            </div>
            <div class="ml-1">
              <v-row>
                <v-col cols="12" lg="12" style="font-weight: 500;font-size: small;">{{title}}</v-col>
                <v-col cols="12" lg="12" class="mt-n8" style="color: black;font-weight: bold;">{{formatMoney(value||0)}}</v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" lg="12" class="mt-n4">
            <div :style="icon_style+'border-radius: 4px;'" class="d-flex justify-center" style="max-height: 18px;">
              <v-icon small :color="icon_color">{{chip_icon}}</v-icon>
              <span style="font-weight: 500;font-size: small;margin-top: -2px;" class="ml-1"><slot name='extra'></slot></span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'DefaultFinancialCard',

    props: {
      value: {
        type: Number,
      },
      title: {
        type: String,
      },
      icon: {
        type: String,
      },
      title_class:{
        type: String,
      },
      icon_color:{
        type: String,
      },
      background_color:{
        type: String,
        default: 'rgba(0,0,0,0.5)'
      },
      chip_icon: {
        type: String,
      }
    },
    computed: {
      icon_style(){
        return "background-color: "+this.background_color+";"
      }
    },
    methods: {
      formatMoney(entry){
        return (Number(entry)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      }
    },
    
  }
</script>

<style lang="scss" scoped>

</style>